export default __webpack_public_path__ + "static/media/img-0537-slovakia-full-face.41ba3820.png";